<script>
  export let apps = [];

  function getStatusConfig(status) {
    switch (status) {
      case 'running': return { color: 'var(--neon-green)', label: 'RUNNING', dot: '🟢' };
      case 'error': return { color: 'var(--neon-red)', label: 'ERROR', dot: '🔴' };
      case 'degraded': return { color: 'var(--neon-orange)', label: 'DEGRADED', dot: '🟡' };
      default: return { color: 'var(--text-tertiary)', label: 'STOPPED', dot: '⚪' };
    }
  }

  function timeAgo(timestamp) {
    if (!timestamp) return null;
    const diff = Date.now() - parseInt(timestamp);
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'Just now';
    if (mins < 60) return `${mins} min ago`;
    const hours = Math.floor(mins / 60);
    return `${hours}h ago`;
  }
</script>

<div class="app-status-card card">
  <div class="card-title">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
    </svg>
    App Status Overview
  </div>

  <div class="status-list" id="app-status-list">
    {#each apps as app}
      {@const cfg = getStatusConfig(app.status)}
      <div class="status-row" class:error={app.status === 'error'}>
        <div class="status-dot-wrap">
          <div class="status-dot" style="background: {cfg.color}; box-shadow: 0 0 8px {cfg.color};"
               class:pulsing={app.status === 'running'}></div>
        </div>
        <div class="status-info">
          <span class="status-app-name">{app.name}</span>
          <span class="status-label" style="color: {cfg.color}">{cfg.label}</span>
        </div>
        <div class="status-meta">
          {#if app.status === 'error' && app.error}
            <span class="error-text">{app.error}</span>
          {:else if app.lastActive}
            <span class="last-active">Last active: {timeAgo(app.lastActive)}</span>
          {:else if app.phase}
            <span class="phase-text">{app.phase}</span>
          {/if}
        </div>
      </div>
    {/each}
  </div>
</div>

<style>
  .app-status-card {
    animation: fadeInUp 0.4s ease 0.1s both;
  }

  .app-status-card .card-title {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .app-status-card .card-title svg {
    color: var(--neon-green);
  }

  .status-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .status-row {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 12px;
    border-radius: var(--radius-sm);
    transition: background 0.2s ease;
  }

  .status-row:hover {
    background: rgba(255, 255, 255, 0.02);
  }

  .status-row.error {
    background: rgba(239, 68, 68, 0.04);
  }

  .status-dot-wrap {
    flex-shrink: 0;
  }

  .status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .status-dot.pulsing {
    animation: pulse 2s infinite;
  }

  .status-info {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }

  .status-app-name {
    font-size: 14px;
    font-weight: 500;
    color: var(--text-primary);
    min-width: 140px;
  }

  .status-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
  }

  .status-meta {
    font-size: 12px;
    color: var(--text-secondary);
    text-align: right;
    flex-shrink: 0;
  }

  .error-text {
    color: var(--neon-red);
  }

  @media (max-width: 768px) {
    .status-info { flex-direction: column; align-items: flex-start; gap: 2px; }
    .status-app-name { min-width: auto; }
    .status-meta { display: none; }
  }
</style>
